import { useState } from "react";

function useProvideAuth() {

  // *For User
  const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));

  // *For Login
  const userLogin = (data) => {
    localStorage.setItem('user', JSON.stringify(data))
    setUser(data)
  };

  // *For User Detail — merges profile data into the existing user object
  const saveUserDetail = (data) => {
    const merged = { ...user, ...data }
    localStorage.setItem('user', JSON.stringify(merged))
    setUser(merged)
  };

  // *For Logout
  const userLogout = async () => {
    setUser(null)
    localStorage.clear()
  };

  return {
    user,
    userLogin,
    userLogout,
    saveUserDetail
  };
}

export default useProvideAuth;
